var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass:
        "fixed top-0 left-0 w-screen h-screen overflow-auto bg-slate-100 scrollbar-lg",
      style: { zIndex: 999 }
    },
    [
      _c("div", { staticClass: "sticky top-0 z-30" }, [
        _c(
          "div",
          {
            staticClass:
              "flex flex-wrap items-center justify-between flex-shrink-0 h-10 px-6 lg:flex-no-wrap gap-y-2 gap-x-4 bg-pure-white"
          },
          [_c("BlBreadcrumbs", { attrs: { breadcrumbs: _vm.breadcrumbs } })],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass:
              "flex items-center justify-between px-6 border-b h-14 bg-pure-white border-slate-400"
          },
          [
            _c("BlTextTitle4", { attrs: { text: _vm.title } }),
            _vm._v(" "),
            _c("BlInputButton", {
              attrs: { type: "plain", icon: "close" },
              on: {
                clicked: function($event) {
                  return _vm.$emit("close-modal")
                }
              }
            })
          ],
          1
        )
      ]),
      _vm._v(" "),
      _vm.modalLoading
        ? _c(
            "div",
            {
              staticClass:
                "flex flex-col items-center justify-center w-full gap-4 py-8",
              style: { minHeight: "calc(100vh - 2.5rem - 3.5rem - 5rem)" }
            },
            [_c("div", { staticClass: "blum-loader" })]
          )
        : _vm.sbtStep === 0
        ? _c(
            "div",
            {
              staticClass: "flex flex-col items-center w-full gap-4 py-8",
              style: { minHeight: "calc(100vh - 2.5rem - 3.5rem - 5rem)" }
            },
            [
              _c(
                "div",
                {
                  staticClass:
                    "flex flex-col gap-4 px-10 py-10 border w-152 bg-pure-white rounded-3xl border-slate-400"
                },
                [
                  _c("BlTextSubtitle1", { attrs: { text: "Target details" } }),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "grid grid-cols-2 gap-2" },
                    [
                      _c("BlInputText", {
                        staticClass: "col-span-2",
                        attrs: { input: _vm.nameInput },
                        on: { changed: _vm.inputHandler }
                      }),
                      _vm._v(" "),
                      _c("BlSelectBox", {
                        class: { "col-span-2": _vm.kind === "client" },
                        attrs: {
                          label: "Data collection method",
                          asterisk: "",
                          placeholder: "Select type",
                          options: _vm.filterTypeOptions,
                          disabled: _vm.duplicateTargetId !== null
                        },
                        on: {
                          change: function($event) {
                            _vm.typeInput = $event
                          }
                        },
                        model: {
                          value: _vm.typeInput,
                          callback: function($$v) {
                            _vm.typeInput = $$v
                          },
                          expression: "typeInput"
                        }
                      }),
                      _vm._v(" "),
                      _c("BlSelectBox", {
                        attrs: {
                          label: "Curriculum",
                          asterisk: "",
                          search: "",
                          placeholder: "Select curriculum",
                          options: _vm.defaultCurriculumOptions,
                          disabled: _vm.defaultCurriculum
                        },
                        on: {
                          change: function($event) {
                            _vm.curriculumIdInput = $event
                          }
                        },
                        model: {
                          value: _vm.curriculumIdInput,
                          callback: function($$v) {
                            _vm.curriculumIdInput = $$v
                          },
                          expression: "curriculumIdInput"
                        }
                      }),
                      _vm._v(" "),
                      _vm.kind === "client"
                        ? _c("BlSelectBox", {
                            attrs: {
                              label: "Status",
                              asterisk: "",
                              placeholder: "Select status",
                              options: _vm.statusOptions
                            },
                            on: {
                              change: function($event) {
                                _vm.statusInput = $event
                              }
                            },
                            model: {
                              value: _vm.statusInput,
                              callback: function($$v) {
                                _vm.statusInput = $$v
                              },
                              expression: "statusInput"
                            }
                          })
                        : _vm._e()
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("BlInputText", {
                    attrs: { input: _vm.descriptionInput },
                    on: { changed: _vm.inputHandler }
                  }),
                  _vm._v(" "),
                  _vm.typeInput.includes("Percentage")
                    ? _c(
                        "div",
                        { staticClass: "grid grid-cols-2 gap-4" },
                        [
                          _c("BlInputText", {
                            attrs: { input: _vm.goalInput },
                            on: { changed: _vm.inputHandler }
                          }),
                          _vm._v(" "),
                          _c("BlSelectBox", {
                            attrs: {
                              label: "Success metric",
                              asterisk: "",
                              placeholder: "Select success metric",
                              options: _vm.successMetricOptions
                            },
                            on: {
                              change: function($event) {
                                _vm.successMetricInput = $event
                              }
                            },
                            model: {
                              value: _vm.successMetricInput,
                              callback: function($$v) {
                                _vm.successMetricInput = $$v
                              },
                              expression: "successMetricInput"
                            }
                          }),
                          _vm._v(" "),
                          _c("BlInputText", {
                            attrs: { input: _vm.trialsInput },
                            on: { changed: _vm.inputHandler }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.typeInput.includes("Duration")
                    ? _c(
                        "div",
                        { staticClass: "grid grid-cols-2 gap-4" },
                        [
                          _c("BlInputTime", {
                            attrs: { input: _vm.timeInput },
                            on: { changed: _vm.inputHandler }
                          }),
                          _vm._v(" "),
                          _c("BlSelectBox", {
                            attrs: {
                              label: "Success metric",
                              asterisk: "",
                              placeholder: "Select success metric",
                              options: _vm.successMetricOptions
                            },
                            on: {
                              change: function($event) {
                                _vm.successMetricInput = $event
                              }
                            },
                            model: {
                              value: _vm.successMetricInput,
                              callback: function($$v) {
                                _vm.successMetricInput = $$v
                              },
                              expression: "successMetricInput"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.typeInput.includes("Pir")
                    ? _c(
                        "div",
                        { staticClass: "grid grid-cols-2 gap-4" },
                        [
                          _c("BlInputText", {
                            attrs: { input: _vm.intervalInput },
                            on: { changed: _vm.inputHandler }
                          }),
                          _vm._v(" "),
                          _c("BlInputText", {
                            attrs: { input: _vm.durationInput },
                            on: { changed: _vm.inputHandler }
                          }),
                          _vm._v(" "),
                          _c("BlInputText", {
                            attrs: { input: _vm.goalInput },
                            on: { changed: _vm.inputHandler }
                          }),
                          _vm._v(" "),
                          _c("BlSelectBox", {
                            attrs: {
                              label: "Success metric",
                              asterisk: "",
                              placeholder: "Select success metric",
                              options: _vm.successMetricOptions
                            },
                            on: {
                              change: function($event) {
                                _vm.successMetricInput = $event
                              }
                            },
                            model: {
                              value: _vm.successMetricInput,
                              callback: function($$v) {
                                _vm.successMetricInput = $$v
                              },
                              expression: "successMetricInput"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.typeInput.includes("Frequency")
                    ? _c(
                        "div",
                        { staticClass: "grid grid-cols-2 gap-4" },
                        [
                          _c("BlInputText", {
                            attrs: { input: _vm.goalFrequencyInput },
                            on: { changed: _vm.inputHandler }
                          }),
                          _vm._v(" "),
                          _c("BlSelectBox", {
                            attrs: {
                              label: "Success metric",
                              asterisk: "",
                              placeholder: "Select success metric",
                              options: _vm.successMetricOptions
                            },
                            on: {
                              change: function($event) {
                                _vm.successMetricInput = $event
                              }
                            },
                            model: {
                              value: _vm.successMetricInput,
                              callback: function($$v) {
                                _vm.successMetricInput = $$v
                              },
                              expression: "successMetricInput"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              ),
              _vm._v(" "),
              _vm.typeInput.includes("Percentage")
                ? _c(
                    "div",
                    {
                      staticClass:
                        "flex flex-col gap-4 px-10 py-10 border w-152 bg-pure-white rounded-3xl border-slate-400"
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "flex flex-col gap-2" },
                        [
                          _c(
                            "div",
                            { staticClass: "flex items-center gap-2" },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "px-2",
                                  style: { transform: "scale(1.375)" }
                                },
                                [
                                  _c("BlInputToggle", {
                                    attrs: { checked: _vm.probingEnableInput },
                                    on: {
                                      changed: function($event) {
                                        _vm.probingEnableInput = !_vm.probingEnableInput
                                      }
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("BlTextSubtitle1", {
                                attrs: { text: "Probing" }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("BlTextBody2", {
                            staticClass: "text-slate-700",
                            attrs: {
                              text:
                                "Probing can be employed to assess a skill at various stages of the therapy. Activating probing gives you additional option to conduct probes during the session."
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.probingEnableInput
                        ? _c(
                            "div",
                            { staticClass: "grid grid-cols-2 gap-4" },
                            [
                              _c("BlInputText", {
                                attrs: { input: _vm.probingTrialInput },
                                on: { changed: _vm.inputHandler }
                              }),
                              _vm._v(" "),
                              _c("BlInputText", {
                                attrs: { input: _vm.probingGoalInput },
                                on: { changed: _vm.inputHandler }
                              })
                            ],
                            1
                          )
                        : _vm._e()
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.typeInput.includes("Prompting")
                ? _c(
                    "div",
                    {
                      staticClass:
                        "flex flex-col gap-4 px-10 py-10 border w-152 bg-pure-white rounded-3xl border-slate-400"
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "flex flex-col gap-2" },
                        [
                          _c("BlTextSubtitle1", {
                            attrs: { text: "Prompting format" }
                          }),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "flex h-10 px-1 py-1 my-2 rounded-lg bg-slate-400"
                            },
                            _vm._l(_vm.promptingFormatOptions, function(opt) {
                              return _c(
                                "div",
                                {
                                  key: opt.value,
                                  staticClass:
                                    "flex items-center justify-center w-full transition-all duration-300 rounded cursor-pointer",
                                  class: [
                                    _vm.promptingFormatInput === opt.value
                                      ? "bg-pure-white"
                                      : "bg-slate-400"
                                  ],
                                  on: {
                                    click: function($event) {
                                      _vm.promptingFormatInput = opt.value
                                    }
                                  }
                                },
                                [
                                  _c("BlTextSubtitle3", {
                                    attrs: { text: opt.label }
                                  })
                                ],
                                1
                              )
                            }),
                            0
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "flex flex-col gap-1" },
                            [
                              _c("BlTextBody2", {
                                staticClass: "font-bold",
                                attrs: {
                                  text:
                                    _vm.promptingFormatInput === "classic"
                                      ? "Frequency-based prompting"
                                      : "Score-based prompting"
                                }
                              }),
                              _vm._v(" "),
                              _vm.promptingFormatInput === "classic"
                                ? _c("BlTextBody2", {
                                    attrs: {
                                      text:
                                        "Tracks how many times each type of prompt is used during the session."
                                    }
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.promptingFormatInput === "custom"
                                ? _c("BlTextBody2", {
                                    attrs: {
                                      text:
                                        "Calculates a percentage score based on the prompts used and the values you assign to each one."
                                    }
                                  })
                                : _vm._e()
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "flex w-full gap-2 px-2 py-2 text-sm rounded bg-cornflower-200"
                            },
                            [
                              _c("BlIcon", {
                                staticClass: "w-4 h-4 mt-1",
                                attrs: {
                                  icon: "toast-info",
                                  color: "cornflower-8"
                                }
                              }),
                              _vm._v(" "),
                              _c(
                                "div",
                                [
                                  _c("BlTextBody2", {
                                    staticClass: "text-cornflower-800",
                                    attrs: {
                                      text:
                                        "Customize default prompts for the entire center by creating them in the Repository."
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "router-link",
                                    {
                                      attrs: {
                                        to:
                                          "/repository/prompting" +
                                          (_vm.promptingFormatInput === "custom"
                                            ? "?tab=custom"
                                            : ""),
                                        target: "_blank"
                                      }
                                    },
                                    [
                                      _c("BlTextBody2", {
                                        staticClass:
                                          "font-bold text-cornflower-800 hover:underline",
                                        attrs: {
                                          text: "Create default prompts"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.promptLoading
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "flex items-center justify-center w-full h-100"
                            },
                            [_c("div", { staticClass: "blum-loader" })]
                          )
                        : _c("div", { staticClass: "flex flex-col gap-4" }, [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "flex items-center justify-center border rounded h-72 bg-slate-100 border-slate-400"
                              },
                              [
                                _c("PromptingPreview", {
                                  style: { transform: "scale(0.5 , 0.5)" },
                                  attrs: { prompts: _vm.defaultPrompts }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "flex flex-col gap-2" },
                              [
                                _c(
                                  "div",
                                  { staticClass: "flex items-center gap-2" },
                                  [
                                    _vm.promptingFormatInput === "classic"
                                      ? _c("div", {
                                          staticClass: "flex-shrink-0 w-4"
                                        })
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.promptingFormatInput === "custom"
                                      ? _c("BlTextSubtitle4", {
                                          staticClass: "flex-shrink-0 w-20",
                                          attrs: { text: "Score (%)" }
                                        })
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _c("BlTextSubtitle4", {
                                      staticClass: "flex-shrink-0 w-10",
                                      attrs: { text: "Code" }
                                    }),
                                    _vm._v(" "),
                                    _c("BlTextSubtitle4", {
                                      staticClass: "flex-shrink-0 w-15",
                                      attrs: { text: "Symbol" }
                                    }),
                                    _vm._v(" "),
                                    _c("BlTextSubtitle4", {
                                      staticClass: "w-full",
                                      attrs: { text: "Prompt name" }
                                    }),
                                    _vm._v(" "),
                                    _c("div", {
                                      staticClass: "flex-shrink-0 w-6"
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _vm.promptingFormatInput === "classic"
                                  ? _c(
                                      "draggable",
                                      {
                                        staticClass: "flex flex-col gap-3",
                                        attrs: { handle: ".handle" },
                                        on: {
                                          update: function($event) {
                                            $event.preventDefault()
                                            return _vm.onMovePosition($event)
                                          }
                                        }
                                      },
                                      _vm._l(_vm.defaultPrompts, function(
                                        prompt
                                      ) {
                                        return _c(
                                          "div",
                                          {
                                            key: prompt.id,
                                            staticClass:
                                              "flex items-center gap-4"
                                          },
                                          [
                                            _vm.promptingFormatInput ===
                                            "classic"
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "flex items-center justify-center flex-shrink-0 w-2 text-sm cursor-move handle text-grey-400"
                                                  },
                                                  [
                                                    _c("BlIcon", {
                                                      staticClass: "w-4 h-4",
                                                      attrs: { icon: "drag" }
                                                    })
                                                  ],
                                                  1
                                                )
                                              : _vm._e(),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "flex flex-grow truncate"
                                              },
                                              [
                                                _c("PromptingClientItem", {
                                                  attrs: {
                                                    prompt: prompt,
                                                    format: "classic",
                                                    disabledDelete: _vm.isUsedToSuccessMetric(
                                                      prompt.name
                                                    ),
                                                    tooltipDelete: _vm.isUsedToSuccessMetric(
                                                      prompt.name
                                                    )
                                                      ? "You cannot delete this prompt because it has been used as a success metric."
                                                      : ""
                                                  },
                                                  on: {
                                                    update: _vm.onUpdatePrompt,
                                                    delete: _vm.onRemovePrompt
                                                  }
                                                })
                                              ],
                                              1
                                            )
                                          ]
                                        )
                                      }),
                                      0
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.promptingFormatInput === "custom"
                                  ? _c(
                                      "div",
                                      { staticClass: "flex flex-col gap-3" },
                                      _vm._l(_vm.groupedPrompts, function(
                                        group
                                      ) {
                                        return _c(
                                          "div",
                                          {
                                            key: group.score,
                                            staticClass: "flex gap-2",
                                            attrs: { id: group.score }
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "flex items-center justify-center flex-shrink-0 w-20 text-center border rounded bg-prim-100 border-prim-100"
                                              },
                                              [
                                                _c("BlTextBody1", {
                                                  staticClass:
                                                    "font-semibold text-light-purple",
                                                  attrs: { text: group.score }
                                                })
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "flex flex-col flex-grow gap-3 truncate"
                                              },
                                              _vm._l(group.prompts, function(
                                                prompt
                                              ) {
                                                return _c(
                                                  "PromptingClientItem",
                                                  {
                                                    key: prompt.id,
                                                    attrs: {
                                                      prompt: prompt,
                                                      format: "custom",
                                                      disabledDelete: _vm.isUsedToSuccessMetric(
                                                        prompt.name
                                                      ),
                                                      tooltipDelete: _vm.isUsedToSuccessMetric(
                                                        prompt.name
                                                      )
                                                        ? "You cannot delete this prompt because it has been used as a success metric."
                                                        : ""
                                                    },
                                                    on: {
                                                      update:
                                                        _vm.onUpdatePrompt,
                                                      delete: _vm.onRemovePrompt
                                                    }
                                                  }
                                                )
                                              }),
                                              1
                                            )
                                          ]
                                        )
                                      }),
                                      0
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "flex" },
                                  [
                                    _c("BlInputButton", {
                                      staticClass: "px-0",
                                      attrs: {
                                        type: "plain",
                                        icon: "plus",
                                        label: "Add prompt"
                                      },
                                      on: {
                                        clicked: function($event) {
                                          _vm.addPromptingOpened = true
                                        }
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "flex flex-col gap-4 px-4 py-4 border rounded bg-slate-100 border-slate-400"
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "flex flex-col gap-2" },
                            [
                              _c("BlTextSubtitle2", {
                                attrs: { text: "Goal and success metric" }
                              }),
                              _vm._v(" "),
                              _vm.promptingFormatInput === "classic"
                                ? _c("BlTextBody2", {
                                    attrs: {
                                      text:
                                        "Mark this target as successful when the client uses a specific prompt at least a certain number of times."
                                    }
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.promptingFormatInput === "custom"
                                ? _c("BlTextBody2", {
                                    attrs: {
                                      text:
                                        "The target passes if the client's score meets the goal you set."
                                    }
                                  })
                                : _vm._e()
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _vm.promptingFormatInput === "classic"
                            ? _c(
                                "div",
                                { staticClass: "grid grid-cols-2 gap-4" },
                                [
                                  _c("BlSelectBox", {
                                    key:
                                      "success-metric-" +
                                      JSON.stringify(_vm.defaultPrompts),
                                    attrs: {
                                      label: "Prompt level",
                                      asterisk: "",
                                      placeholder: "Select prompt",
                                      options: _vm.defaultPrompts.map(function(
                                        i
                                      ) {
                                        return { value: i.name, label: i.name }
                                      })
                                    },
                                    on: {
                                      change: function($event) {
                                        _vm.successMetricInput = $event
                                      }
                                    },
                                    model: {
                                      value: _vm.successMetricInput,
                                      callback: function($$v) {
                                        _vm.successMetricInput = $$v
                                      },
                                      expression: "successMetricInput"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("BlInputText", {
                                    attrs: { input: _vm.goalPromptInput },
                                    on: { changed: _vm.inputHandler }
                                  })
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.promptingFormatInput === "custom"
                            ? _c(
                                "div",
                                { staticClass: "grid grid-cols-2 gap-4" },
                                [
                                  _c("BlInputText", {
                                    attrs: { input: _vm.goalInput },
                                    on: { changed: _vm.inputHandler }
                                  }),
                                  _vm._v(" "),
                                  _c("BlSelectBox", {
                                    attrs: {
                                      label: "Success metric",
                                      asterisk: "",
                                      placeholder: "Select success metric",
                                      options: _vm.successMetricOptions
                                    },
                                    on: {
                                      change: function($event) {
                                        _vm.successMetricInput = $event
                                      }
                                    },
                                    model: {
                                      value: _vm.successMetricInput,
                                      callback: function($$v) {
                                        _vm.successMetricInput = $$v
                                      },
                                      expression: "successMetricInput"
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e()
                        ]
                      )
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.typeInput.includes("Sbt")
                ? _c(
                    "div",
                    {
                      staticClass:
                        "flex flex-col gap-4 px-10 py-10 border w-152 bg-pure-white rounded-3xl border-slate-400"
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "flex flex-col gap-2" },
                        [
                          _c("BlTextSubtitle1", {
                            attrs: { text: "Prompt settings" }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.promptLoading
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "flex items-center justify-center w-full h-100"
                            },
                            [_c("div", { staticClass: "blum-loader" })]
                          )
                        : _c("div", { staticClass: "flex flex-col gap-4" }, [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "flex items-center justify-center border rounded h-72 bg-slate-100 border-slate-400"
                              },
                              [
                                _c("SbtPromptPreview", {
                                  style: { transform: "scale(0.5 , 0.5)" },
                                  attrs: { prompts: _vm.defaultPrompts }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c("div", { staticClass: "flex flex-col gap-2" }, [
                              _c(
                                "div",
                                { staticClass: "flex items-center gap-2" },
                                [
                                  _c("div", {
                                    staticClass: "flex-shrink-0 w-2"
                                  }),
                                  _vm._v(" "),
                                  _c("BlTextSubtitle4", {
                                    staticClass: "flex-shrink-0 w-20",
                                    attrs: { text: "Score (%)" }
                                  }),
                                  _vm._v(" "),
                                  _c("BlTextSubtitle4", {
                                    staticClass: "flex-shrink-0 w-10",
                                    attrs: { text: "Code" }
                                  }),
                                  _vm._v(" "),
                                  _c("BlTextSubtitle4", {
                                    staticClass: "w-full",
                                    attrs: { text: "Prompt" }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "flex flex-col gap-3" },
                                _vm._l(_vm.groupedPrompts, function(group) {
                                  return _c(
                                    "div",
                                    {
                                      key: group.score,
                                      staticClass: "flex gap-2",
                                      attrs: { id: group.score }
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "flex items-center justify-center flex-shrink-0 w-20 text-center border rounded bg-prim-100 border-prim-100"
                                        },
                                        [
                                          _c("BlTextBody1", {
                                            staticClass:
                                              "font-semibold text-light-purple",
                                            attrs: { text: group.score }
                                          })
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "flex flex-col flex-grow gap-3 truncate"
                                        },
                                        _vm._l(group.prompts, function(prompt) {
                                          return _c("SbtPromptClientItem", {
                                            key: prompt.id,
                                            attrs: {
                                              prompt: prompt,
                                              disabledDelete: _vm.isUsedToSuccessMetric(
                                                prompt.name
                                              ),
                                              tooltipDelete: _vm.isUsedToSuccessMetric(
                                                prompt.name
                                              )
                                                ? "You cannot delete this prompt because it has been used as a success metric."
                                                : ""
                                            },
                                            on: {
                                              update: _vm.onUpdatePrompt,
                                              delete: _vm.onRemovePrompt
                                            }
                                          })
                                        }),
                                        1
                                      )
                                    ]
                                  )
                                }),
                                0
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "flex" },
                                [
                                  _c("BlInputButton", {
                                    staticClass: "px-0",
                                    attrs: {
                                      type: "plain",
                                      icon: "plus",
                                      label: "Add prompt"
                                    },
                                    on: {
                                      clicked: function($event) {
                                        _vm.addPromptSbtOpened = true
                                      }
                                    }
                                  })
                                ],
                                1
                              )
                            ])
                          ])
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.typeInput && !_vm.typeInput.includes("Sbt")
                ? _c(
                    "div",
                    {
                      staticClass:
                        "flex flex-col gap-4 px-10 py-10 border w-152 bg-pure-white rounded-3xl border-slate-400"
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "flex flex-col gap-2" },
                        [
                          _c(
                            "div",
                            { staticClass: "flex items-center gap-2" },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "p-1 bg-orange-300",
                                  style: { borderRadius: "4px" }
                                },
                                [
                                  _c("BlIcon", {
                                    staticClass: "w-5 h-5",
                                    attrs: { icon: "tooltip" }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("BlTextSubtitle1", {
                                attrs: { text: "Action recommendations" }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("BlTextBody2", {
                            staticClass: "text-slate-700",
                            attrs: {
                              text:
                                "Get recommendation after the session when client passes certain conditions."
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("ActionRecommendationInput", {
                        attrs: {
                          totalSuccess: _vm.totalSuccessInput,
                          consecutiveSuccess: _vm.consecutiveSuccessInput
                        },
                        on: {
                          input: function($event) {
                            return _vm.onInputActionRecommendation($event)
                          }
                        }
                      })
                    ],
                    1
                  )
                : _vm._e()
            ]
          )
        : _vm.sbtStep == 1
        ? _c("NewTaskOverlay", {
            attrs: {
              defaultTasks: _vm.defaultTasks,
              tasksCodes: _vm.tasksCodes
            },
            on: {
              addTask: _vm.onAddTask,
              updateTask: _vm.onUpdateTask,
              removeTask: _vm.onRemoveTask
            }
          })
        : _vm.sbtStep == 2
        ? _c("NewProblemOverlay", {
            attrs: {
              defaultProblemBehaviors: _vm.defaultProblemBehaviors,
              problemBehaviors: _vm.problemBehaviors
            },
            on: {
              addProblemBehavior: _vm.onAddProblemBehavior,
              updateProblemBehavior: _vm.onUpdateProblemBehavior,
              removeProblemBehavior: _vm.onRemoveProblemBehavior
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "sticky bottom-0 z-10 flex items-center justify-between flex-shrink-0 h-20 px-6 border-t bg-pure-white border-slate-400"
        },
        [
          _c("div", { staticClass: "flex flex-col gap-2" }, [
            _c(
              "div",
              { staticClass: "flex items-center gap-2 overflow-hidden" },
              [
                _c("div", { staticClass: "w-20 h-1 rounded bg-light-purple" }),
                _vm._v(" "),
                _vm.typeInput.includes("Sbt")
                  ? _c("div", { staticClass: "flex gap-2" }, [
                      _c("div", {
                        staticClass: "w-20 h-1 rounded ",
                        class:
                          _vm.sbtStep >= 1 ? "bg-light-purple" : "bg-slate-400"
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "w-20 h-1 rounded",
                        class:
                          _vm.sbtStep >= 2 ? "bg-light-purple" : "bg-slate-400"
                      })
                    ])
                  : _vm._e()
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "flex items-center gap-1" },
              [
                _c(
                  "div",
                  {
                    staticClass:
                      "grid flex-shrink-0 w-6 h-6 border rounded-full place-items-center",
                    class: [
                      _vm.isDisabledSubmit
                        ? "border-slate-600"
                        : "border-success-400"
                    ]
                  },
                  [
                    _vm.isDisabledSubmit && !_vm.typeInput.includes("Sbt")
                      ? _c("BlTextSubtitle4", { attrs: { text: "1" } })
                      : _vm.typeInput.includes("Sbt") && _vm.sbtStep === 0
                      ? _c("BlTextSubtitle4", { attrs: { text: "1" } })
                      : _vm.typeInput.includes("Sbt") && _vm.sbtStep === 1
                      ? _c("BlTextSubtitle4", { attrs: { text: "2" } })
                      : _vm.typeInput.includes("Sbt") &&
                        _vm.sbtStep === 2 &&
                        _vm.isDisabledSubmit
                      ? _c("BlTextSubtitle4", { attrs: { text: "3" } })
                      : _vm.typeInput.includes("Sbt") &&
                        _vm.sbtStep === 2 &&
                        !_vm.isDisabledSubmit
                      ? _c("BlIcon", {
                          staticClass: "w-6 h-6",
                          attrs: { icon: "check", color: "success-4" }
                        })
                      : _c("BlIcon", {
                          staticClass: "w-6 h-6",
                          attrs: { icon: "check", color: "success-4" }
                        })
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.sbtStep == 0
                  ? _c("BlTextSubtitle4", { attrs: { text: "Target details" } })
                  : _vm._e(),
                _vm._v(" "),
                _vm.sbtStep == 1 && _vm.typeInput.includes("Sbt")
                  ? _c("BlTextSubtitle4", { attrs: { text: "Add tasks" } })
                  : _vm._e(),
                _vm._v(" "),
                _vm.sbtStep == 2 && _vm.typeInput.includes("Sbt")
                  ? _c("BlTextSubtitle4", {
                      attrs: { text: "Add problem behaviors" }
                    })
                  : _vm._e()
              ],
              1
            )
          ]),
          _vm._v(" "),
          _vm.typeInput.includes("Sbt")
            ? _c(
                "div",
                { staticClass: "flex gap-4" },
                [
                  _vm.sbtStep > 0
                    ? _c("BlInputButton", {
                        attrs: {
                          type: "outlined",
                          label: "Back",
                          loading: _vm.submitLoading
                        },
                        on: { clicked: _vm.onBack }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.sbtStep === 0
                    ? _c("BlInputButton", {
                        attrs: {
                          type: "outlined",
                          label: "Next",
                          disabled: _vm.isDisabledSubmit,
                          loading: _vm.submitLoading
                        },
                        on: { clicked: _vm.onNext }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.sbtStep < 2 && _vm.sbtStep > 0
                    ? _c("BlInputButton", {
                        attrs: {
                          type: "outlined",
                          label: "Next",
                          disabled: _vm.isDisabledNext,
                          loading: _vm.submitLoading
                        },
                        on: { clicked: _vm.onNext }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.sbtStep === 2
                    ? _c("BlInputButton", {
                        attrs: {
                          label: "Create target",
                          disabled: _vm.isDisabledSubmit,
                          loading: _vm.submitLoading
                        },
                        on: { clicked: _vm.onSubmit }
                      })
                    : _vm._e()
                ],
                1
              )
            : _c("BlInputButton", {
                attrs: {
                  label: "Create target",
                  disabled: _vm.isDisabledSubmit,
                  loading: _vm.submitLoading
                },
                on: { clicked: _vm.onSubmit }
              })
        ],
        1
      ),
      _vm._v(" "),
      _vm.addPromptingOpened
        ? _c(
            "BlBackdrop",
            {
              attrs: { title: "Add new prompt", label: "Add prompt" },
              on: {
                "backdrop-close": function($event) {
                  return _vm.closeAddPromptModal()
                },
                "backdrop-action": function($event) {
                  return _vm.onAddPrompt("Prompting")
                }
              }
            },
            [
              _c("div", { staticClass: "px-8", style: { width: "40rem" } }, [
                _c(
                  "div",
                  { staticClass: "grid items-center grid-cols-5 gap-4 py-4" },
                  [
                    _vm.promptingFormatInput === "custom"
                      ? _c("BlInputText", {
                          staticClass: "col-span-2",
                          attrs: { input: _vm.scoreInput },
                          on: { changed: _vm.inputHandler }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _c("BlInputText", {
                      class: {
                        "col-span-4": _vm.promptingFormatInput === "classic",
                        "col-span-2": _vm.promptingFormatInput === "custom"
                      },
                      attrs: { input: _vm.codeInput },
                      on: { changed: _vm.inputHandler }
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "relative col-span-1" }, [
                      _c(
                        "label",
                        {
                          staticClass: "relative mb-1",
                          attrs: { "data-id": "prompt-symbol" }
                        },
                        [
                          _c("BlTextBody3", {
                            attrs: {
                              "data-id": "prompt-symbol",
                              text: "Symbol"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "relative flex items-center justify-between w-full h-10 px-4 border rounded cursor-pointer",
                          class: [
                            _vm.symbolOpened
                              ? "border-light-purple"
                              : "border-grey-200"
                          ],
                          attrs: { "data-id": "prompt-symbol" },
                          on: {
                            click: function($event) {
                              $event.preventDefault()
                              _vm.symbolOpened = !_vm.symbolOpened
                            }
                          }
                        },
                        [
                          _vm.promptShapeInput && _vm.promptColorInput
                            ? _c("BlIcon", {
                                staticClass: "w-6 h-6",
                                attrs: {
                                  icon: "prompt-" + _vm.promptShapeInput,
                                  color: _vm.promptColorInput
                                }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _c("BlIcon", {
                            staticClass:
                              "absolute w-5 h-5 transition-all duration-300 right-4",
                            style: _vm.symbolOpened ? "rotate: 180deg" : "",
                            attrs: {
                              "data-id": "prompt-symbol",
                              icon: "chevron-down"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.symbolOpened
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "absolute right-0 z-10 px-4 py-4 mt-2 space-y-4 overflow-y-auto border rounded shadow-md w-88 max-h-48 bg-pure-white border-grey-200",
                              attrs: { "data-id": "prompt-symbol" }
                            },
                            [
                              _c(
                                "div",
                                { attrs: { "data-id": "prompt-symbol" } },
                                [
                                  _c("BlTextBody2", {
                                    attrs: { text: "Colors:" }
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "flex gap-2",
                                      attrs: { "data-id": "prompt-symbol" }
                                    },
                                    _vm._l(
                                      Object.keys(_vm.promptColors),
                                      function(color) {
                                        return _c("div", {
                                          key: color,
                                          staticClass:
                                            "flex-shrink-0 w-6 h-6 border-2 rounded cursor-pointer",
                                          class: [
                                            _vm.promptColorInput === color
                                              ? "border-light-purple"
                                              : "border-transparent"
                                          ],
                                          style: {
                                            backgroundColor:
                                              _vm.promptColors[color]
                                                .primaryColor
                                          },
                                          attrs: {
                                            "data-id": "prompt-symbol",
                                            title: color
                                          },
                                          on: {
                                            click: function($event) {
                                              _vm.promptColorInput = color
                                            }
                                          }
                                        })
                                      }
                                    ),
                                    0
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { attrs: { "data-id": "prompt-symbol" } },
                                [
                                  _c("BlTextBody2", {
                                    attrs: { text: "Shapes:" }
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "flex gap-2",
                                      attrs: { "data-id": "prompt-symbol" }
                                    },
                                    _vm._l(Object.keys(_vm.shapes), function(
                                      shape
                                    ) {
                                      return _c(
                                        "div",
                                        {
                                          key: shape,
                                          staticClass:
                                            "flex-shrink-0 w-8 h-8 text-center cursor-pointer",
                                          attrs: {
                                            "data-id": "prompt-symbol",
                                            title: shape
                                          },
                                          on: {
                                            click: function($event) {
                                              _vm.promptShapeInput = shape
                                            }
                                          }
                                        },
                                        [
                                          _c("BlIcon", {
                                            attrs: {
                                              "data-id": "prompt-symbol",
                                              icon: _vm.shapes[shape].icon,
                                              color:
                                                _vm.promptShapeInput === shape
                                                  ? "prompt-active"
                                                  : "prompt-idle"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    }),
                                    0
                                  )
                                ],
                                1
                              )
                            ]
                          )
                        : _vm._e()
                    ]),
                    _vm._v(" "),
                    _c("BlInputText", {
                      staticClass: "col-span-5",
                      attrs: { input: _vm.promptNameInput },
                      on: { changed: _vm.inputHandler }
                    })
                  ],
                  1
                )
              ])
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.addPromptSbtOpened
        ? _c(
            "BlBackdrop",
            {
              attrs: { title: "Add new prompt", label: "Add prompt" },
              on: {
                "backdrop-close": function($event) {
                  return _vm.closeAddPromptModal()
                },
                "backdrop-action": function($event) {
                  return _vm.onAddPrompt("Sbt")
                }
              }
            },
            [
              _c("div", { staticClass: "px-8", style: { width: "40rem" } }, [
                _c(
                  "div",
                  { staticClass: "grid items-center grid-cols-6 gap-4 py-4" },
                  [
                    _c("BlInputText", {
                      staticClass: "col-span-3",
                      attrs: { input: _vm.scoreInput },
                      on: { changed: _vm.inputHandler }
                    }),
                    _vm._v(" "),
                    _c("BlInputText", {
                      staticClass: "col-span-3",
                      attrs: { input: _vm.codeInput },
                      on: { changed: _vm.inputHandler }
                    }),
                    _vm._v(" "),
                    _c("BlInputText", {
                      staticClass: "col-span-6",
                      attrs: { input: _vm.promptNameInput },
                      on: { changed: _vm.inputHandler }
                    })
                  ],
                  1
                )
              ])
            ]
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-25240bd6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-25240bd6","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/clients/target/overlay/NewTargetOverlay.vue
// module id = null
// module chunks = 